module.exports = __webpack_public_path__ + "img/Vision_photo01.81c68a37.png";